import { ISistemaAvaliacao } from "@deltasge/marauders-map";

import { createActionWithPayload } from "store/helpers";
import { ActionTypes } from "./types";
import { createAction } from "@reduxjs/toolkit";

export const request = createActionWithPayload<number>(ActionTypes.REQUEST);
export const success = createActionWithPayload<ISistemaAvaliacao>(
  ActionTypes.SUCCESS
);
export const failure = createAction<void>(ActionTypes.FAILURE);
